import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Clarity from '@microsoft/clarity';
import { environment } from '../../../environments/environment';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles, keycloak } = authData;

  if (authenticated) {
    // 2. Den Username abrufen
    const username = keycloak.tokenParsed?.['email'] || 'Unbekannter Benutzer';

    if (keycloak.idToken && environment.production) {
      Clarity.identify(
        keycloak.idToken,
        keycloak.sessionId,
        undefined,
        username,
      );
      if (!environment.production) {
        console.log('Clarity identify called with:', {
          userId: keycloak.idToken,
          sessionId: keycloak.sessionId,
          username: username,
        });
      }
    }

    return true;
  }

  const router = inject(Router);
  return router.parseUrl('/');
};

export const canActivateAuthRole =
  createAuthGuard<CanActivateFn>(isAccessAllowed);
